import { Card, CardContent, Typography, styled } from "@mui/material";
import { Question } from "../types";
import { grey } from "@mui/material/colors";
import QuestionJsonDialog from "./QuestionJsonDialog";
import { FC, useState } from "react";

interface QuestionEditCardProps {
  question: Question
  handleUpdate: (question: Question) => void;
}

const QuestionEditCard: FC<QuestionEditCardProps> = ({ question, handleUpdate }) => {

  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const CalculatorCardContainer = styled(Card)({
    width: "22rem", // Three rows
    height: "100%",
    cursor: "pointer",
    ":hover": { backgroundColor: grey[100] },
  });

  return (
    <CalculatorCardContainer variant="outlined">
      <CardContent onClick={handleOpen}>
        <Typography variant="h5">{question.questionId}</Typography>
        <Typography variant="body1">{question.question}</Typography>
      </CardContent>
      <QuestionJsonDialog question={question} open={open} handleClose={handleClose} handleUpdate={handleUpdate} variant="edit" />
    </CalculatorCardContainer>
  )
};

export default QuestionEditCard;